/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ForceUpdateNftOwnershipBody
 */
export interface ForceUpdateNftOwnershipBody {
    /**
     * 
     * @type {string}
     * @memberof ForceUpdateNftOwnershipBody
     */
    trackerId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ForceUpdateNftOwnershipBody
     */
    isUpdateAll: boolean;
}

export function ForceUpdateNftOwnershipBodyFromJSON(json: any): ForceUpdateNftOwnershipBody {
    return ForceUpdateNftOwnershipBodyFromJSONTyped(json, false);
}

export function ForceUpdateNftOwnershipBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForceUpdateNftOwnershipBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trackerId': !exists(json, 'trackerId') ? undefined : json['trackerId'],
        'isUpdateAll': json['isUpdateAll'],
    };
}

export function ForceUpdateNftOwnershipBodyToJSON(value?: ForceUpdateNftOwnershipBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trackerId': value.trackerId,
        'isUpdateAll': value.isUpdateAll,
    };
}


